import { createApi } from '@reduxjs/toolkit/query/react';
import { authBaseQuery } from '../utils/authBaseQuery';

const baseUrl = process.env.NEXT_PUBLIC_API_CHECKOUT;

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: authBaseQuery({
    baseUrl,
  }),
  endpoints: (builder) => ({
    signIn: builder.mutation({
      query: (credentials) => ({
        url: 'bookings-core/api/v1/users/signIn',
        method: 'POST',
        body: credentials,
      }),
    }),
  }),
});

export const { useSignInMutation } = authApi;
